import type { FC } from "react";
import { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import { selectLastAiMessage, selectLastHumanMessage } from "app/pages/sales-intelligence/modules/ai-agent/store";
import type { AiThreadMessage, HumanThreadMessage } from "app/pages/sales-intelligence/modules/ai-agent/types/thread";

import RetryMessageStrategy from "../../components/message-strategy/CustomErrorStrategy/RetryMessageStrategy";
import { MESSAGE_RETRY_ERROR_CODES } from "../../constants/content";

interface ICustomAiErrorContainerProps {
    messageId: string;
    code: number;
    onRetry: (messageContent?: string) => void;
}

export const CustomErrorStrategyContainer: FC<ICustomAiErrorContainerProps> = ({ messageId, code, onRetry }) => {
    const [isRetryHidden, setIsRetryHidden] = useState(false);

    const lastHumanMessage: HumanThreadMessage | undefined = useSelector(selectLastHumanMessage);
    const lastAiMessage: AiThreadMessage | undefined = useSelector(selectLastAiMessage);

    const isLastMessage = lastAiMessage?.id === messageId;

    const isRetryErrorCode = MESSAGE_RETRY_ERROR_CODES.has(code);

    useEffect(() => {
        setIsRetryHidden(false);
    }, [messageId]);

    const handleRetry = (): void => {
        if (lastHumanMessage) {
            setIsRetryHidden(true);
            onRetry(lastHumanMessage?.content);
        }
    };

    if (isLastMessage && isRetryErrorCode && !isRetryHidden) {
        return <RetryMessageStrategy onRetry={handleRetry} />;
    }

    return null;
};
